import LegalPageLayout, { Section } from "@/pages/LegalPageLayout";

export default function Terms() {
  return (
    <LegalPageLayout
      label="§ LEGAL · TERMS"
      title="Terms of Use"
      updated="17 August 2026"
    >
      <p>
        These Terms govern access to agenaix.com and authorised Agenaix
        accounts. Agenaix is currently a pre-launch project based in Dubai,
        United Arab Emirates. Contact: agenaix.ai@gmail.com.
      </p>

      <Section title="1. Pre-launch status">
        <p>
          The website and platform are currently provided for evaluation,
          preparation, and authorised testing. Public registration is closed.
          Website descriptions are informational and do not constitute a
          binding offer, quotation, service commitment, or guarantee.
        </p>
        <p>
          Commercial services, prices, delivery dates, and project obligations
          will apply only when separately confirmed in writing under an
          appropriate agreement after the required business arrangements are in
          place.
        </p>
      </Section>

      <Section title="2. Eligibility and accounts">
        <p>
          You must be at least 18 years old and legally able to accept these
          Terms. If acting for an organisation, you confirm that you have
          authority to act for it.
        </p>
        <p>
          You are responsible for protecting account credentials and for
          activity under your account. Notify us promptly if you suspect
          unauthorised access.
        </p>
      </Section>

      <Section title="3. Acceptable use">
        <p>
          You must not use Agenaix unlawfully; interfere with security or
          availability; attempt unauthorised access; upload malicious code;
          infringe intellectual property, privacy, or confidentiality rights;
          misrepresent identity or authority; or use the platform to harm,
          deceive, exploit, or unlawfully monitor another person.
        </p>
      </Section>

      <Section title="4. Your content">
        <p>
          You retain ownership of content you lawfully submit. You grant
          Agenaix a limited permission to host, process, reproduce, and transmit
          that content only as needed to operate requested features, secure the
          service, and provide support.
        </p>
        <p>
          You confirm that you have the rights and permissions necessary to
          provide the content. Do not upload regulated, highly sensitive, or
          third-party confidential information without appropriate authority
          and safeguards.
        </p>
      </Section>

      <Section title="5. AI outputs">
        <p>
          AI-generated content may be inaccurate, incomplete, outdated, or
          unsuitable for a particular purpose. It is not professional legal,
          medical, financial, safety, or regulatory advice. You are responsible
          for reviewing outputs and decisions before using or sharing them.
        </p>
      </Section>

      <Section title="6. Third-party services">
        <p>
          Agenaix may depend on third-party infrastructure, authentication,
          hosting, storage, APIs, or software. Third-party services may have
          their own terms and privacy practices, and their availability is not
          controlled by Agenaix.
        </p>
      </Section>

      <Section title="7. Intellectual property">
        <p>
          Agenaix branding, website design, platform software, and materials
          supplied by Agenaix are protected by applicable intellectual property
          laws. These Terms do not transfer ownership of Agenaix intellectual
          property. Separate project deliverables will be governed by the
          applicable written project agreement.
        </p>
      </Section>

      <Section title="8. Availability and changes">
        <p>
          Pre-launch features may change, be suspended, or be removed without
          notice. We may restrict access where reasonably necessary for
          security, maintenance, legal compliance, or misuse prevention.
        </p>
      </Section>

      <Section title="9. Disclaimers and liability">
        <p>
          To the extent permitted by applicable law, the pre-launch platform is
          provided on an “as available” basis without warranties that it will be
          uninterrupted, error-free, or suitable for a particular purpose.
        </p>
        <p>
          Nothing in these Terms excludes or limits liability that cannot
          lawfully be excluded or limited.
        </p>
      </Section>

      <Section title="10. Privacy">
        <p>
          Our Privacy Policy explains how personal data is handled and forms
          part of these Terms.
        </p>
      </Section>

      <Section title="11. Governing law">
        <p>
          These Terms are governed by the applicable laws of the United Arab
          Emirates. Subject to applicable mandatory law, disputes will be
          submitted to the competent courts of Dubai.
        </p>
      </Section>

      <Section title="12. Changes and contact">
        <p>
          We may update these Terms as the platform and legal arrangements
          develop. The effective date above identifies the current version.
          Questions may be sent to agenaix.ai@gmail.com.
        </p>
      </Section>
    </LegalPageLayout>
  );
}
